import React, { useRef, useState, useEffect } from "react";
import validator from "validator";
import emailjs from "@emailjs/browser";
import { SERVER_URL } from "../globalVariables";

const Newsletter = () => {
  const [error, setError] = useState("");
  const form = useRef();
  const [contactInformations, setContactInformations] = useState({
    email: "",
  });

  const sendSubscription = (e) => {
    e.preventDefault();

    if (contactInformations.email !== "") {
      if (validator.isEmail(contactInformations.email)) {
        fetch(`${SERVER_URL}/api/newsletter`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(contactInformations),
        })
          .then((response) => response.json())
          .then((res) => {
            if (res.msg !== "subscribed") {
              emailjs
                .sendForm(
                  "service_j98yodi",
                  "template_v1ohdsx",
                  form.current,
                  "cKc78rMKbgska16W1"
                )
                .then(
                  () => {
                    setError("200");
                  },
                  (error) => {
                    console.log(error.text);
                  }
                );
            } else {
              setError("You are already subscribed to our newsletter.");
            }
          })
          .catch((error) => {
            console.log(error);
            setError("An error has occurred! please try again.");
          });
      } else {
        setError("Email is invalid.");
      }
    } else {
      setError("Please complete email field");
    }
  };

  return (
    <div className="scrollTo space-y-8" id="newsletter">
      <h2 className="text-[28px] lg:text-[36px] text-white font-bold w-full leading-none">
        Join Us
      </h2>

      <div className="space-y-3 md:space-y-0 md:flex w-full md:space-x-7">
        <div className="w-full md:max-w-[330px]">
          <p className="text-xl">
            There is no art gallery without great artists and collectors. While
            we focus on the quality of the art, we strongly promote the need to
            offer a diverse and original set of creations to feed every soul and
            heart.
          </p>
        </div>

        <div className="space-y-3 md:space-y-4 w-full">
          <p className="text-[20px] font-semibold">
            Register to our Newsletter to stay up to date about TheGallery and
            key milestones
          </p>

          <p className="text-lg">
            Please provide your email address to subscribe
          </p>

          <form
            ref={form}
            onSubmit={sendSubscription}
            className="space-y-3 md:space-y-0 md:flex md:space-x-5 "
          >
            <div className="flex py-2 px-7 border-2 border-white rounded-full w-full ">
              <input
                type="email"
                name="user_email"
                className="outline-none bg-transparent w-full placeholder:text-white text-[17px]"
                placeholder={"My email address"}
                onFocus={(e) => (e.target.placeholder = "")}
                onBlur={(e) => (e.target.placeholder = "My email address")}
                onChange={(event) => {
                  setContactInformations({
                    email: event.target.value,
                  });
                }}
              />
            </div>

            <div className="flex justify-end">
              <input
                type="submit"
                value="Subscribe"
                className="border-2 border-[#33c7b6] rounded-full text-[#33c7b6] text-[17px] px-7 py-2 cursor-pointer"
              />
            </div>
          </form>

          {error === "200" ? (
            <div>
              <p className="text-sm text-[#33c7b6]">
                Thank you! Your submission has been sent.
              </p>
            </div>
          ) : (
            <div>
              <p className="text-sm text-red-500">{error}</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Newsletter;
